import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { LoadingService } from "./refact/shared/components/loading/services/loading.service";

import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, Event } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";
import { AliasColecaoService } from "./core/services/alias-colecao.service";
import { UrlThemeService } from "./core/services/url-theme.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements AfterViewInit, OnInit {
  isLoading = this.loadingService.loading$;

  title = "MODAUP";

  urlsExcluidas = [
    "/api/v1/ClienteMalote/info",
    "/api/v1/Referencia",
    "/api/v1/notificacao/novas",
    "/api/v1/notificacao/visualizar-todas",
    "/api/v1/eCommerce/",
    "/api/v1/logsintegracao/",
    "api/v1/VendaInUp/ReprocessarVendasBluve",
    "/api/v2/ClienteMalote/info",
    "api/Tef/",
    "api/v2/NotaContingencia/Transmitir"
  ];

  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private aliasColecaoService: AliasColecaoService,
    private urlThemeService: UrlThemeService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.urlThemeService.apply();

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.loadingService.setLoading(true);
      } else if (
        event instanceof NavigationEnd || 
        event instanceof NavigationCancel || 
        event instanceof NavigationError
      ) {
        this.loadingService.setLoading(false);
      }
    });
  }

  ngOnInit(): void {
    const isLoggedIn = localStorage.getItem('loggedIn') === 'true';
    const hasModules = localStorage.getItem('modulos') === 'true';
    
    if (isLoggedIn && hasModules) {
      this.aliasColecaoService.carregarAliasDaRede();
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      const loader: HTMLElement | null =
        document.getElementById('initial-loader');
      if (loader) loader.remove();
    }
  }
}
